/* Jane Lushka v1.2: colour dots on product cards (phase 4, collection:4, K28).
 *
 * Every card prints <product-card-colors class="jl-card__dots" data-group data-current> with the current colour dot
 * (snippets/product-card-colors.liquid), so the row height is there before this script runs. When a card with an
 * ItemNumber group comes within 300px of the viewport, this script asks
 *   {{ routes.root }}collections/all/<group>?sections=product-card-colors   (sections/product-card-colors.liquid)
 * ONCE per group per page (promises cached in memory, shared by every card of that group), removes the card's own
 * product, drops sold-out members unless the section says data-sold-dots="true" (settings.card_sold_out_dots),
 * appends dots up to 5 in total (4 below 768px) and, for the rest, a "+N" (visible "+N" hidden from assistive tech, plus
 * a visually hidden "N more colours"). A failed request leaves the current dot alone (no error UI).
 * Colour preview (owner, 15 Oct): a mouse over another colour's dot (hover devices) or keyboard focus on it shows that
 * colour's card photo (data-img / data-srcset from the section) over the card's own photo, in <img class="jl-card__img-alt">
 * inside the image link, once loaded (.is-alt on .jl-card__media, jl-card.css); leaving the dots, or the card's own
 * dot, shows the card's photo again. A click or tap on a dot opens that colour.
 *
 * Re-scan: the custom element's connectedCallback (defined only when nobody defined product-card-colors before),
 * plus jl:collection-render, jl:recently-viewed-shown, shopify:section:load and a MutationObserver on document.body
 * filtered to .jl-card (cards added by filters, load more, Recently viewed, the Wishlist page, the theme editor).
 * Each re-scan first releases observed rows that left the page before they came into view (F14: a filter or sort
 * re-render no longer leaves detached cards held by the IntersectionObserver).
 * Public: window.JLCardColors.scan(root).
 */
(function () {
  'use strict';

  if (window.JLCardColors) return;

  // dots in total, the card's own included (owner, 15 Oct: show the other colours): 5 from 768px, 4 on phones
  function maxDots() {
    return window.matchMedia && window.matchMedia('(min-width: 768px)').matches ? 5 : 4;
  }
  var cache = {};
  var io = null;
  var watched = [];
  var scanQueued = false;

  function routeRoot() {
    try {
      var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      return r || '/';
    } catch (e) {
      return '/';
    }
  }

  function load(group) {
    if (cache[group]) return cache[group];
    var url = routeRoot() + 'collections/all/' + encodeURIComponent(group) + '?sections=product-card-colors';
    // no Accept: application/json header: with it Shopify answers with the collection JSON instead of the section
    cache[group] = fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (json) {
        var html = json && json['product-card-colors'];
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('[data-jl-dots]');
        if (!src) return null;
        var items = [];
        var lis = src.querySelectorAll('li[data-handle]');
        for (var i = 0; i < lis.length; i++) {
          items.push({
            handle: lis[i].getAttribute('data-handle'),
            available: lis[i].getAttribute('data-available') === '1',
            li: lis[i]
          });
        }
        return {
          sold: src.getAttribute('data-sold-dots') === 'true',
          more: src.getAttribute('data-more') || '+[n]',
          moreLabel: src.getAttribute('data-more-label') || '',
          items: items
        };
      })
      .catch(function () {
        return null;
      });
    return cache[group];
  }

  function moreBadge(data, n) {
    var span = document.createElement('span');
    span.className = 'jl-card__more';
    var shown = document.createElement('span');
    shown.setAttribute('aria-hidden', 'true');
    shown.textContent = data.more.replace('[n]', n);
    span.appendChild(shown);
    if (data.moreLabel) {
      var hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      hidden.textContent = data.moreLabel.replace('[n]', n);
      span.appendChild(hidden);
    }
    return span;
  }

  function fill(el) {
    if (el.__jlDotsDone) return;
    el.__jlDotsDone = true;
    var group = el.getAttribute('data-group');
    if (!group) return;
    var current = el.getAttribute('data-current') || '';
    load(group).then(function (data) {
      if (!data || !el.isConnected) return;
      var list = el.querySelector('.jl-card__dots-list');
      if (!list || el.querySelector('.jl-card__more')) return;
      var others = [];
      for (var i = 0; i < data.items.length; i++) {
        var it = data.items[i];
        if (it.handle === current) continue;
        if (!it.available && !data.sold) continue;
        others.push(it);
      }
      if (!others.length) return;
      var room = Math.max(0, maxDots() - list.children.length);
      var add = Math.min(room, others.length);
      var frag = document.createDocumentFragment();
      for (var j = 0; j < add; j++) {
        var li = document.importNode(others[j].li, true);
        li.removeAttribute('data-handle');
        li.removeAttribute('data-available');
        frag.appendChild(li);
      }
      list.appendChild(frag);
      var rest = others.length - add;
      if (rest > 0) el.appendChild(moreBadge(data, rest));
    });
  }

  function observe(el) {
    if (el.__jlDotsSeen) return;
    el.__jlDotsSeen = true;
    if (!el.getAttribute('data-group')) {
      el.__jlDotsDone = true;
      return;
    }
    if (io) {
      io.observe(el);
      watched.push(el);
    } else fill(el);
  }

  // stop observing rows that were removed before they intersected; one put back later is observed again
  function release() {
    if (!io) return;
    var keep = [];
    for (var i = 0; i < watched.length; i++) {
      var el = watched[i];
      if (el.isConnected) {
        keep.push(el);
      } else {
        io.unobserve(el);
        el.__jlDotsSeen = false;
      }
    }
    watched = keep;
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('product-card-colors.jl-card__dots');
    for (var i = 0; i < els.length; i++) observe(els[i]);
  }

  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    var run = function () {
      scanQueued = false;
      release();
      scan(document);
    };
    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    else setTimeout(run, 16);
  }

  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          io.unobserve(entries[i].target);
          var k = watched.indexOf(entries[i].target);
          if (k > -1) watched.splice(k, 1);
          fill(entries[i].target);
        }
      }
    }, { rootMargin: '300px 0px 300px 0px' });
  }

  if (window.customElements && !window.customElements.get('product-card-colors')) {
    try {
      window.customElements.define('product-card-colors', class extends HTMLElement {
        connectedCallback() {
          if (this.classList.contains('jl-card__dots')) observe(this);
        }
      });
    } catch (e) { /* defined elsewhere in the meantime: the scans below still fill the dots */ }
  }

  ['jl:collection-render', 'jl:recently-viewed-shown', 'shopify:section:load'].forEach(function (name) {
    document.addEventListener(name, queueScan);
  });

  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var nodes = records[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if ((n.classList && n.classList.contains('jl-card')) || (n.querySelector && n.querySelector('.jl-card'))) {
            queueScan();
            return;
          }
        }
      }
    });
    var start = function () {
      if (document.body) mo.observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
  }

  /* ---------- colour preview on the card photo ---------- */

  function cardMedia(dot) {
    var card = dot.closest('.jl-card');
    return card ? card.querySelector('.jl-card__media') : null;
  }

  function showAlt(dot) {
    var media = cardMedia(dot);
    if (!media) return;
    var src = dot.getAttribute('data-img');
    if (!src || dot.getAttribute('aria-current') === 'true') {
      media.classList.remove('is-alt');
      return;
    }
    var link = media.querySelector('.jl-card__img-link');
    if (!link) return;
    var img = link.querySelector('.jl-card__img-alt');
    if (!img) {
      img = document.createElement('img');
      img.className = 'jl-card__img-alt';
      img.alt = '';
      img.decoding = 'async';
      img.width = 600;
      img.height = 800;
      var first = media.querySelector('.jl-card__img');
      var sizes = first && first.getAttribute('sizes');
      if (sizes) img.setAttribute('sizes', sizes);
      link.appendChild(img);
    }
    media.__jlAltWant = src;
    if (img.getAttribute('data-src') === src) {
      if (img.complete && img.naturalWidth) media.classList.add('is-alt');
      return;
    }
    media.classList.remove('is-alt');
    img.setAttribute('data-src', src);
    img.onload = function () {
      if (media.__jlAltWant === src && img.getAttribute('data-src') === src) media.classList.add('is-alt');
    };
    var srcset = dot.getAttribute('data-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    else img.removeAttribute('srcset');
    img.src = src;
  }

  function hideAlt(dot) {
    var media = cardMedia(dot);
    if (!media) return;
    media.__jlAltWant = null;
    media.classList.remove('is-alt');
  }

  var hoverMq = window.matchMedia ? window.matchMedia('(hover: hover)') : null;

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    if (hoverMq && !hoverMq.matches) return;
    var dot = e.target && e.target.closest && e.target.closest('.jl-card .jl-card__dot');
    if (dot) showAlt(dot);
  });

  document.addEventListener('pointerout', function (e) {
    var dot = e.target && e.target.closest && e.target.closest('.jl-card .jl-card__dot');
    if (!dot) return;
    var to = e.relatedTarget;
    var next = to && to.closest && to.closest('.jl-card .jl-card__dot');
    if (next && next.closest('.jl-card') === dot.closest('.jl-card')) return;
    hideAlt(dot);
  });

  document.addEventListener('focusin', function (e) {
    var dot = e.target && e.target.closest && e.target.closest('.jl-card .jl-card__dot');
    if (dot) showAlt(dot);
  });

  document.addEventListener('focusout', function (e) {
    var dot = e.target && e.target.closest && e.target.closest('.jl-card .jl-card__dot');
    if (!dot) return;
    var to = e.relatedTarget;
    var next = to && to.closest && to.closest('.jl-card .jl-card__dot');
    if (next && next.closest('.jl-card') === dot.closest('.jl-card')) return;
    hideAlt(dot);
  });

  window.JLCardColors = { scan: scan };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
})();
